export const VIEWING_APPLY_REMINDER_TEXT =
  'REMINDER: The primary applicant must use the same email or mobile number used for their viewing registration to apply.'
